import { FC } from "react";
import Layout from "components/Layout";
import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import DataTable from "components/DataTable";
import CrudLayout from "components/CrudLayout";
import {
  Button,
  Stack,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Heading,
} from "@chakra-ui/react";
import ActionsButton from "components/ActionsButton";
// import FormUser from "components/FormUser";
// import { FaSync } from "react-icons/fa";
import { useDeleteDialog } from "hooks";
import ConfirmDialog from "components/ConfirmDialog";
import { useParams } from "react-router-dom";
import { IDevice } from "interfaces/device";
import useDevice from "hooks/useDevice";
import { FaChevronDown } from "react-icons/fa";
import SmartDoorLockFormModal from "components/SmartDoorLockFormModal";

const Devices: FC = () => {
  const { id } = useParams();
  const {
    data,
    loading,
    onSubmitForm,
    isOpenForm,
    onCloseForm,
    openAddForm,
    openEditForm,
    formType,
    formValue,
    isLoadingAction,
    deleteDevice,
  } = useDevice(id as string);
  const { isOpenDelete, deleteId, onOpendelete, onCloseDelete } =
    useDeleteDialog();
  const columnHelper = createColumnHelper<IDevice>();

  const getDeviceType = (type: string) => {
    let deviceType = "";
    switch (type) {
      case "camera":
        deviceType = "CCTV";
        break;

      case "lock":
        deviceType = "Smart Door Lock";
        break;

      default:
        deviceType = "Unknown";
        break;
    }
    return deviceType;
  };

  const columns: ColumnDef<IDevice, any>[] = [
    columnHelper.accessor("label", {
      cell: (info) => info.getValue(),
      header: "Nama Perangkat",
    }),
    columnHelper.accessor("type", {
      cell: (info) => getDeviceType(info.getValue()),
      header: "Jenis Perangkat",
    }),
    columnHelper.accessor("config", {
      header: () => null,
      cell: (info) => (
        <ActionsButton
          id={info.row.index.toString()}
          actions={[
            {
              label: "Edit",
              onClick: () => openEditForm(info.row.index, "lock"),
            },
            {
              label: "Hapus",
              onClick: () => onOpendelete(info.row.index.toString()),
            },
          ]}
        />
      ),
      meta: {
        sx: {
          textAlign: "right",
        },
      },
      enableGlobalFilter: false,
      enableSorting: false,
    }),
  ];

  return (
    <Layout isPrivate>
      <CrudLayout
        breadcrumb={[
          { title: "List Rumah", link: "/houses" },
          { title: "Perangkat Terinstal", link: "#" },
        ]}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={4}
          px={6}
        >
          <Heading size="md">Blok : {data?.blok}</Heading>
          {/* <Button leftIcon={<FaFile />}>Tambah</Button> */}
          <Menu>
            <MenuButton as={Button} rightIcon={<FaChevronDown />}>
              Tambah Perangkat
            </MenuButton>
            <MenuList>
              <MenuItem>CCTV</MenuItem>
              <MenuItem onClick={() => openAddForm("lock")}>
                Smart Door Lock
              </MenuItem>
            </MenuList>
          </Menu>
        </Stack>
        {data && (
          <DataTable
            isLoading={loading}
            columns={columns}
            data={data.devices ? data.devices : []}
          />
        )}
      </CrudLayout>
      <SmartDoorLockFormModal
        isOpen={isOpenForm && formType === "lock"}
        onClose={onCloseForm}
        onSubmit={onSubmitForm}
        formValue={formValue.initialValues as IDevice}
        isLoading={isLoadingAction}
      />
      <ConfirmDialog
        loading={isLoadingAction}
        isOpen={isOpenDelete}
        onClose={onCloseDelete}
        onConfirm={async () => {
          await deleteDevice(parseInt(deleteId));
        }}
      />
    </Layout>
  );
};

export default Devices;
